import { render, staticRenderFns } from "./WsDataTable.vue?vue&type=template&id=225c7436&scoped=true"
import script from "./WsDataTable.vue?vue&type=script&lang=js"
export * from "./WsDataTable.vue?vue&type=script&lang=js"
import style0 from "./WsDataTable.vue?vue&type=style&index=0&id=225c7436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c7436",
  null
  
)

export default component.exports